module.exports = __webpack_public_path__ + "static/media/reinaldo_viveiros_carraro.16631566.jpg";